// import {getLogger} from 'aurelia-logging';
// const logger = getLogger('events');

export class RepetitionCreatedOrUpdatedEvent {
    constructor(repetitions, created) {
        this.repetitions = repetitions;
        this.created = created;
    }
}
